<template>
    <div class="loan_wrap">
        <div class="red_top_bg">
			<div class="back_left" @click="$router.back()"></div>
			<div class="big_tit">{{ $t('贷款申请') }}</div>
		</div>
        <form class="form">
            <div class="item">
                <span class="t">
                    {{$t('申请人')}}
                </span>
                <input
                     v-model="ruleForm.name"
                    type="text"
                    class="inp"
                    :placeholder="$t('真实姓名')"
                >
            </div>
            <div class="item">
                <span class="t">
                    {{$t('联系电话')}}
                </span>
                <input
                     v-model="ruleForm.phone"
                    type="text"
                    class="inp"
                    :placeholder="$t('请输入联系电话')"
                >
            </div>

            <div class="item">
                <span class="t">
                    {{$t('贷款期限')}}
                </span>
                <van-popover
                    v-model="showPopover"
                    trigger="click"
                    :actions="actions"
                    @select="onSelect"
                >
                    <template #reference>
                        <input
                            v-model="repayment_day_text"
                            type="text"
                            class="inp"
                            :placeholder="$t('选择贷款期限')"
                            readonly
                        >
                    </template>
                </van-popover>
            </div>
            <div class="item">
                <span class="t">
                    {{$t('申请金额')}}
                </span>
                <input
                     v-model="ruleForm.amount"
                    type="number"
                    class="inp"
                    :placeholder="$t('请输入申请金额')"
                >
            </div>
            <div class="item">
                <span class="t">
                    {{$t('贷款利率')}}
                </span>
                <input
                     v-model="interest_rate"
                    type="text"
                    class="inp"
                    placeholder="0%"
                    readonly
                >
            </div>
            <div class="item">
                <span class="t">
                    {{$t('放款方式')}}
                </span>
                <input
                     v-model="text"
                    type="number"
                    class="inp"
                    :placeholder="$t('账户余额')"
                    readonly
                >
            </div>
            <div class="item">
                <span class="t">
                   {{$t('国籍')}}
                </span>
                <van-popover
                    v-model="countryShow"
                    trigger="click"
                    :actions="countrys"
                    @select="onSelect2"
                >
                    <template #reference>
                        <input
                            v-model="ruleForm.country"
                            type="text"
                            class="inp"
                            :placeholder="$t('国籍')"
                            readonly
                        >
                    </template>
                </van-popover>
            </div>
            <div class="item">
                <span class="t">
                    <span class="red">*</span>{{$t('证件号码/护照号码')}}
                </span>
                <input
                     v-model="ruleForm.card_num"
                    type="number"
                    class="inp"
                    :placeholder="$t('证件号码/护照号码')"
                >
            </div>
            <div class="item">
                <span class="t">
                    <span class="red">*</span>{{$t('证件号码')}}/{{ $t('上传护照') }}
                </span>
                <div class="item_img">
                    <van-uploader v-model="fileList1" multiple preview-size="100" :max-count="1"  :after-read="afterRead"/>
                    <van-uploader v-model="fileList2" multiple preview-size="100" :max-count="1" :after-read="afterRead2"/>
                    <van-uploader v-model="fileList3" multiple preview-size="100" :max-count="1" :after-read="afterRead3"/>
                </div>
            </div>
            <div class="item">
                <span class="t">
                    {{$t('拍照示例')}}
                </span>
                <div class="item_img">
                    <img src="@/assets/images/01.png" />
                    <img src="@/assets/images/02.png" />
                    <img src="@/assets/images/03.png" />
                </div>
            </div>
        </form>
        <div class="text_box">
            <van-checkbox v-model="checked" shape="square">{{ $t('我已阅读并同意') }}</van-checkbox>
            <a class="text" @click="$router.push('/loanContract')">《{{$t('借款协议')}}》</a>
        </div>
        <div class="bottom">
            <button  class="button" @click="sellerRegister">
                {{$t('提交申请')}}
            </button>
        </div>
        <div style="height: 100px;"></div>
    </div>
</template>

<script>
import Fetch from '../../utils/fetch';
import { Toast, Icon } from 'vant'
import Api from "../../interface/index";
import footers from '@/components/bsFooter.vue'
import axios from 'axios'
export default {
    components:{
        footers
    },
    data() {
        return {
            checked:false,
            showPopover: false,
            // 通过 actions 属性来定义菜单选项
            actions: [],
            countrys:[],
            countryShow:false,
            countryText:'',
            interest_rate:'',
            ruleForm: {
                name:'',            // 借款人姓名 
                card_num :'',       // 身份证号   
                phone:'',           //  联系电话 
                amount:'',           //  借贷金额 
                repayment_day_id:'',    //  还款天数ID
                country:'',
                kyc_front_img:'',   //身份正面
                kyc_reverse_side_img:'',    //反面
                kyc_handheld_img:''
            },
            text:'', 
            repayment_day_text:'',
            fileList1: [],
            fileList2: [],
            fileList3: [],
            rules: {
                amount: [
                    { required: true, message: this.$t('请输入金额'), trigger: 'blur' },
                ],
            },
        }
    },
    async created() {
        this.$parent.footer('item', false);
        Fetch("/loan/countrys").then((r) => {
            this.countrys = r.data.map(x => {
                return {text:x.name,code:x.code}
            })
		});    
        Fetch('/loan/repaymentDays').then(r => {
            this.actions = r.data.list.map(x => {
                return {
                    createtime:x.createtime,
                    day: x.day,
                    id: x.id,
                    interest_rate: x.interest_rate,
                    text: x.name,
                    penalty_rate: x.penalty_rate,
                    updatetime: x.updatetime
                }
            })
        }) 
    },
    methods: {
        afterRead(e) {
            let formData = new FormData();
			formData.append('file', e.file);
			formData.append('language', this.$i18n.locale || "en_us");
			formData.append('token', localStorage.getItem('token'));
			axios.post(Api.commonUrl + "/api/index/bank_link_upload", formData).then(res => {
				this.ruleForm.kyc_front_img = res.data.data
			})
        },
        afterRead2(e) {
            let formData = new FormData();
			formData.append('file', e.file);
			formData.append('language', this.$i18n.locale || "en_us");
			formData.append('token', localStorage.getItem('token'));
			axios.post(Api.commonUrl + "/api/index/bank_link_upload", formData).then(res => {
				this.ruleForm.kyc_reverse_side_img = res.data.data
			})
        },
        afterRead3(e) {
            let formData = new FormData();
			formData.append('file', e.file);
			formData.append('language', this.$i18n.locale || "en_us");
			formData.append('token', localStorage.getItem('token'));
			axios.post(Api.commonUrl + "/api/index/bank_link_upload", formData).then(res => {
				this.ruleForm.kyc_handheld_img = res.data.data
			})
        },
        onSelect(action) {
            this.interest_rate = action.interest_rate + '%'
            console.log(this.interest_rate)
            this.repayment_day_text = action.text
            this.ruleForm.repayment_day_id = action.id
        },
        onSelect2(action) {
            console.log(action,'action')
            this.countryText = action.text
            this.ruleForm.country = action.text
        },
         // 提交按钮
         sellerRegister() {
            if(!this.checked){
                Toast('请阅读并同意协议')
                return
            }
            let data = this.ruleForm
            Fetch('/loan/apply',data).then(r => {
                if(r.msg) {
                    Toast(r.msg)
                }
            }) 
        },
    }
}
</script>

<style lang="scss" scoped>
.red_top_bg {
	position: fixed;
	top: 0;
	z-index: 10;
}
.loan_wrap {
    padding-top:44px;
    .form {
        margin:15px auto;
        width: 90%;
        height:fit-content;
    }
    .item {
        height: fit-content;
        font-size: 14px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding-bottom: 4px;
        .item_img {
            width:100%;
            display: flex;
            justify-content: space-between;
            img {
                display: block;
                width: 32%;
            }
        }
        .t {
            display: flex;
            align-items: center;
            width: 100%;
            height: 30px;
            .people {
                width: 23px;
                height: 20px;
            }

            img {
                width: 100%;
                height: 100%;
            }
        }

        input {
            width:100%;
            height:48px;
            border:1px solid #F2F3F5;
            margin-bottom: 3px;
            padding:0 10px;
            border-radius:6px;
        }
    }
    .bottom {
        width:90%;
        height:46px;
        margin:0 auto;
        display:flex;
        align-items:center;
        justify-content: center;
        background:#F89900;
        border-radius:6px;
        .button {
            width:100%;
            height:100%;
            color:#fff;
            font-size:16px;
        }
    }
}
.red {
    color:red;
}
.van-popover__wrapper {
    width:100%;
}
.text_box {
    width: 100%;
    padding: 24px 0px 40px 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-top: 1px solid #eee;
    font-size: 16px;
    .text {
        color: #F89900;
    }
}

</style>
<style>
.van-popover {
    width: 90%;
}
.van-popover__action {
    width: 100% !important;

}
.van-popover__action-text {
    justify-content: flex-start !important;
}
.van-popover--light .van-popover__content {
    height: fit-content;
    max-height: 400px;
    overflow-y: scroll;
}
</style>